__turbopack_context__.v({
  "passport_benefit_explanation": "NiPUJG_passport_benefit_explanation",
  "passport_benefit_headline": "NiPUJG_passport_benefit_headline",
  "passport_benefit_headline_intro": "NiPUJG_passport_benefit_headline_intro",
  "passport_benefit_plm_link_lg": "NiPUJG_passport_benefit_plm_link_lg",
  "passport_benefit_plm_link_small": "NiPUJG_passport_benefit_plm_link_small",
  "passport_benefit_screen": "NiPUJG_passport_benefit_screen",
  "passport_benefit_screen_ctas": "NiPUJG_passport_benefit_screen_ctas",
  "passport_benefit_screen_passport_compass": "NiPUJG_passport_benefit_screen_passport_compass",
  "passport_benefit_screen_support": "NiPUJG_passport_benefit_screen_support",
  "passport_benefit_station_lockup": "NiPUJG_passport_benefit_station_lockup",
  "video_image": "NiPUJG_video_image",
  "video_player_container": "NiPUJG_video_player_container",
  "video_player_iframe": "NiPUJG_video_player_iframe",
});
